import RavelloService from '@/services/ravello'

export const Airbnb = {
	name: 'MarketMath Airbnb Data',
	route: 'market-airbnb',
}

export const AirbnbCrawlers = {
	name: 'Crawlers',
	route: 'market-airbnb-crawlers',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} crawlers` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const AirbnbCrawler = {
	name: 'New crawler',
	route: 'market-airbnb-crawler',
	params: ['market', 'crawler'],
	lazyName: {
		fn: async (market, crawler) => (crawler === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/airbnbcrawlers/${crawler}?fields=name`)
		),
		params: ['market', 'crawler'],
		field: 'name',
	},
}


export const AirbnbListings = {
	name: 'Listings',
	route: 'market-airbnb-listings',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} listings` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const AirbnbListing = {
	name: 'Listings',
	route: 'market-airbnb-listing',
	params: ['market', 'listing'],
	lazyName: {
		fn: async (market, listing) => RavelloService.get(`/v2/markets/${market}/airbnblistings/${listing}?fields=listing_id`),
		params: ['market', 'listing'],
		field: 'listing_id',
	},
}

export const AnalysisPresets = {
	name: 'AnalysisPresets',
	route: 'market-analysispresets',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} analysis presets` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const AnalysisPreset = {
	name: 'New analysispreset',
	route: 'market-analysispreset',
	params: ['market', 'preset'],
	lazyName: {
		fn: async (market, preset) => (preset === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/analysispresets/${preset}?fields=name`)
		),
		params: ['market', 'preset'],
		field: 'name',
	},
}

export const Areas = {
	name: 'Areas',
	route: 'market-areas',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} areas` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const Area = {
	name: 'New area',
	route: 'market-area',
	params: ['market', 'area'],
	lazyName: {
		fn: async (market, area) => (area === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/areas/${area}?fields=name`)
		),
		params: ['market', 'area'],
		field: 'name',
	},
}

export const Cities = {
	name: 'Cities',
	route: 'market-cities',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} cities` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const City = {
	name: 'New city',
	route: 'market-city',
	params: ['market', 'city'],
	lazyName: {
		fn: async (market, city) => (city === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/cities/${city}?fields=name`)
		),
		params: ['market', 'city'],
		field: 'name',
	},
}

export const Complexes = {
	name: 'Complexes',
	route: 'market-complexes',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} complexes` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const Complex = {
	name: 'New complex',
	route: 'market-complex',
	params: ['market', 'complex'],
	lazyName: {
		fn: async (market, complex) => (complex === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/complexes/${complex}?fields=name`)
		),
		params: ['market', 'complex'],
		field: 'name',
	},
}

export const Crawlers = {
	name: 'Crawlers',
	route: 'market-crawlers',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} crawlers` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const Crawler = {
	name: 'New crawler',
	route: 'market-crawler',
	params: ['market', 'crawler'],
	lazyName: {
		fn: async (market, crawler) => (crawler === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/crawlers/${crawler}?fields=title`)
		),
		params: ['market', 'crawler'],
		field: 'title',
	},
}

export const Listings = {
	name: 'Listings',
	route: 'market-listings',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} listings` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const Listing = {
	name: 'New listing',
	route: 'market-listing',
	params: ['market', 'listing'],
	lazyName: {
		fn: async (market, listing) => (listing === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/listings/${listing}?fields=title`)
		),
		params: ['market', 'listing'],
		field: 'title',
	},
}

export const ListingAnalysis = {
	name: 'Analysis',
	route: 'market-listing-analysis',
}

export const Managers = {
	name: 'MarketMath Managers',
	route: 'marketmanagers',
}

export const Manager = {
	name: 'New manager',
	route: 'marketmanager',
	params: ['manager'],
	lazyName: {
		fn: async manager => (manager === 'new'
			? null
			: RavelloService.get(`/v2/marketmanagers/${manager}`)
		),
		params: ['manager'],
		field: 'name',
	},
}

export const Markets = {
	name: 'MarketMath',
	route: 'markets',
}

export const Market = {
	name: 'New market',
	route: 'market',
	params: ['market'],
	lazyName: {
		fn: async market => (market === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}`)
		),
		params: ['market'],
		field: 'name',
	},
}

export const Participants = {
	name: 'Participants',
	route: 'market-participants',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} participants` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const Participant = {
	name: 'New participant',
	route: 'market-participant',
	params: ['market', 'participant'],
	lazyName: {
		fn: async (market, participant) => {
			if (participant === 'new') { return null }
			const entry = await RavelloService.get(`/v2/markets/${market}/participants/${participant}?fields=first_name,last_name`)
			return { name: `${entry.first_name} ${entry.last_name}` }
		},
		params: ['market', 'participant'],
		field: 'name',
	},
}

export const Realtors = {
	name: 'Realtors',
	route: 'market-realtors',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} realtors` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const Realtor = {
	name: 'New realtor',
	route: 'market-realtor',
	params: ['market', 'realtor'],
	lazyName: {
		fn: async (market, realtor) => (realtor === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/realtors/${realtor}?fields=name`)
		),
		params: ['market', 'realtor'],
		field: 'name',
	},
}

export const Sponsors = {
	name: 'MarketMath Sponsors',
	route: 'marketsponsors',
}

export const Sponsor = {
	name: 'New sponsor',
	route: 'marketsponsor',
	params: ['sponsor'],
	lazyName: {
		fn: async sponsor => (sponsor === 'new'
			? null
			: RavelloService.get(`/v2/marketsponsors/${sponsor}`)
		),
		params: ['sponsor'],
		field: 'name',
	},
}

export const Surveys = {
	name: 'Surveys',
	route: 'market-surveys',
	params: ['market'],
	lazyName: {
		fn: async (market) => {
			const entry = await RavelloService.get(`/v2/markets/${market}?fields=name`)
			return { name: `${entry.name} surveys` }
		},
		params: ['market'],
		field: 'name',
	},
}

export const Survey = {
	name: 'New survey',
	route: 'market-survey',
	params: ['market', 'survey'],
	lazyName: {
		fn: async (market, survey) => (survey === 'new'
			? null
			: RavelloService.get(`/v2/markets/${market}/surveys/${survey}?fields=name`)
		),
		params: ['market', 'survey'],
		field: 'name',
	},
}

export const SurveyResults = {
	name: 'Survey Results',
	route: 'market-survey-results',
	params: ['market', 'survey'],
	lazyName: {
		fn: async (market, survey) => {
			const entry = await RavelloService.get(`/v2/markets/${market}/surveys/${survey}?fields=name`)
			return { name: `${entry.name} results` }
		},
		params: ['market', 'survey'],
		field: 'name',
	},
}

export const SurveyResult = {
	name: 'Result',
	route: 'market-survey-result',
}

export const Variances = {
	name: 'Variances Report',
	route: 'market-variances',
}
